import ConsumptionReport from "../components/ConsumptionReport";
import { actualVersusTheoreticalConfig } from "../configs/actualVersusTheoretical";

const ActualVersusTheoreticalConsumption = ({ outlets }) => {
  return (
    <ConsumptionReport {...actualVersusTheoreticalConfig} outlets={outlets} />
  )
};

export default ActualVersusTheoreticalConsumption;
